import { Component, ElementRef, EventEmitter, HostListener, Injectable, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Company, ConnectionService } from '../../services/Connection/connection.service';
import { placeCounter, typeInterface } from 'src/app/shared/Interfaces/company';
import { SharedService } from '../../services/shared/shared.service';
import { OrderService } from '../../services/Order/order.service';

@Component({
  selector: 'app-top-header',
  templateUrl: './top-header.component.html',
  styleUrl: './top-header.component.css'
})
@Injectable({
  providedIn: 'root'
})
export class TopHeaderComponent implements OnInit {
  @ViewChild('input') input!: ElementRef;
  @Output() showInput = new EventEmitter<boolean>();
  public placeCounter!: placeCounter;
  placeActive: boolean = false;
  typeParam!: typeInterface;
  company!: Company;
  buttonClicked = false;
  nameFantasyCompany: string = '';
  imgLogo: string = '';
  includeDivHeader = false;
  scrollTopPosition: number = 0;
  isClicked = false;
  filter: string = '';
  activeInput: boolean = false

  constructor(private connection: ConnectionService, public sharedService: SharedService, public orderService: OrderService){
    this.sharedService.filter$.subscribe((data) =>{
      this.filter = data;
    })
    this.sharedService.activeInput$.subscribe((data) =>{
      this.activeInput = data
    })
  }

  ngOnInit(): void {

    this.connection.company$.subscribe((newCompany) =>{
      if(newCompany){
        this.company = newCompany
        this.nameFantasyCompany = this.company.company.companyName.toUpperCase();
        this.imgLogo = this.company.company.logo;
      }

    })

    this.connection.typeParam$.subscribe((newTypeParam) => {
      this.typeParam = newTypeParam;
    })

    this.orderService.placeCounter$.subscribe((newPlace) =>{
      if(newPlace.id_place != ''){
        this.placeCounter = newPlace;
        this.placeActive = true;
      }
      
    })
  }


  //assim que clicado ele da um scroll até o topo da pagina
  scrollToTop(){
    const scrollTop = 0;
    window.scrollTo({ top: scrollTop, behavior: 'auto'});

    this.isClicked = true;

    setTimeout(() => {
      this.isClicked = false;
    }, 500);

  }

  //Inclui a div quando o usuario da scroll até um ponto
  includeDivBar(){
    this.scrollTopPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    if(window.innerWidth <= 846)
    {
      if(this.company.configs.closeScheduling == 1){
        if(this.scrollTopPosition >= 300)
        {
          this.includeDivHeader = true;
        }
        else{
          this.includeDivHeader = false;
        }
      }
      else{
        if(this.scrollTopPosition >= 300)
        {
          this.includeDivHeader = true;
        }
        else{
          this.includeDivHeader = false;
        }
      }

    }
    else{
      this.includeDivHeader = false;
    }
  }

  //Abre o input de pesquisa no Top Menu
  openInput(){
    this.sharedService.updateActive(true);
  }

  //Recebe o evento de scroll
  @HostListener('window:scroll')
  onScroll(): boolean  {
    this.includeDivBar();
    return false;
  }

  //Recebe o evento de resize
  @HostListener('window:resize')
  onResize(){
    this.includeDivBar()
  }


}
